import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-summary-modal",
  templateUrl: "./summary-modal.component.html",
  styleUrls: ["./summary-modal.component.sass"],
})
export class SummaryModalComponent implements OnInit {
  drugs: any[];
  drugLength:any;
  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.drugs = data.drug;
    this.drugLength = this.drugs.length - 1;
  }

  ngOnInit(): void {}

  closeDialog(): void {
    this.dialog.closeAll();
  }
}
